// import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import './App.css';
import { SITE_CONFIG } from './config';
import ServiceSuspended from './components/ui/ServiceSuspended';

function App() {
  /* Temporarily disabled right-click and copy shortcuts for development
  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => e.preventDefault();
    // Disable common copy/cut keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey || e.metaKey) &&
        ['c', 'u', 's', 'a', 'p'].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  */

  if (SITE_CONFIG.isSuspended) {
    return <ServiceSuspended />;
  }

  return <RouterProvider router={router} />;
}

export default App;
